export default __webpack_public_path__ + "static/media/Harness of the Ravenflight.000331a4.jpg";